export class TransportManagementReportLoad {
  public static readonly type = '[TransportManagementReport] Load';
}

export class TransportManagementReportInitialState {
  public static readonly type = '[TransportManagementReport] Set Initial State';
}
